module.exports = __webpack_public_path__ + "img/product2.594ce47.webp";